import type { OCRValidationResponse } from "@/types/ocr";
import type { OCRResultLike } from "./ocr-progressive-timing";

/**
 * Maps an OCRValidationResponse (backend shape, uses `detectado`) to the
 * OCRResultLike shape expected by OCRProgressiveReceipt (uses `encontrado`).
 *
 * Returns null when given null — safe to drop directly into a useMemo dep.
 */
export function mapOCRResponseToProgressive(
  response: OCRValidationResponse | null
): OCRResultLike | null {
  if (!response) return null;
  return {
    sucesso: response.sucesso,
    valor: {
      encontrado: response.valor.detectado ?? null,
      esperado: response.valor.esperado ?? undefined,
      match: response.valor.match,
    },
    terminal: {
      encontrado: response.terminal.detectado ?? null,
      esperado: response.terminal.esperado ?? undefined,
      match: response.terminal.match,
    },
    // data field doesn't exist in OCRValidationResponse — animation runs ~1400ms with 2 fields
  };
}
